import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

interface DeletePageParams {
  id: number;
  schemaId?: number;
}

export function useDeletePage() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: ({ id }: DeletePageParams) => 
      api.admin.pages.deletePage({ params: { id } }),
    onSuccess: (_, variables) => {
      // Invalidate pages list for this schema
      if (variables.schemaId) {
        queryClient.invalidateQueries({ queryKey: ['admin', 'pages', { schema_id: variables.schemaId }] });
      }
      // Also invalidate general pages queries
      queryClient.invalidateQueries({ queryKey: ['admin', 'pages'] });
      // Invalidate schema to update pages_count
      queryClient.invalidateQueries({ queryKey: ['admin', 'page-schemas'] });
      
      toaster.create({
        title: "Page deleted successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useDeletePage] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while deleting the page.';
      
      toaster.create({
        title: "Failed to delete page",
        description: errorMessage,
        type: "error",
      });
    },
  });
}
